import React from "react";
import Logo from "../../assets/WhatsApp Image 2025-12-17 at 3.56.49 PM copy.jpeg";
import { FaWhatsapp , FaInstagram, FaLinkedinIn, FaYoutube } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export const PublicFooter = () => {

  const navigate = useNavigate();

  return (
    <footer className="bg-secondary-100 text-gray-800">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 py-12">

        {/* Grid Layout */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-10 text-center sm:text-left">

          {/* Logo Section */}
          <div className="flex flex-col items-center md:items-start">
            <img
              onClick={() => navigate("/")}
              src={Logo}
              alt="SAN Technovation Logo"
              className="w-40 mb-4 cursor-pointer"
            />

            <p className="text-sm leading-6 max-w-xs">
              Engineering tomorrow's technology with precision and intelligent design.
            </p>

            {/* Social Icons */}
            <div className="flex gap-4 mt-4">
              <a
                href="https://api.whatsapp.com/send/?phone=917418169679&text&type=phone_number&app_absent=0"
                className="p-2 bg-white rounded-full shadow hover:bg-primary-600 hover:text-white transition"
              >
                <FaWhatsapp size={16} />
              </a>

              <a
                href="https://www.instagram.com/san_group_of_companies?utm_source=qr&igsh=MXQ3NHd1dmFqMW16ZA%3D%3D"
                className="p-2 bg-white rounded-full shadow hover:bg-primary-600 hover:text-white transition"
              >
                <FaInstagram size={16} />
              </a>

              <a
                href="https://in.linkedin.com/company/san-technovation"
                className="p-2 bg-white rounded-full shadow hover:bg-primary-600 hover:text-white transition"
              >
                <FaLinkedinIn size={16} />
              </a>

              <a
                href="https://www.youtube.com/@SAN_TECHNOVATION"
                className="p-2 bg-white rounded-full shadow hover:bg-primary-600 hover:text-white transition"
              >
                <FaYoutube size={16} />
              </a>
            </div>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-lg font-semibold mb-4">
              Company
            </h3>

            <ul className="space-y-2 text-sm">

              <li
                onClick={() => navigate("/about")}
                className="hover:text-primary-600 transition duration-300 cursor-pointer"
              >
                About Us
              </li>

              <li
                onClick={() => navigate("/courses")}
                className="hover:text-primary-600 transition duration-300 cursor-pointer"
              >
                Courses
              </li>

            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">
              Quick Links
            </h3>

            <ul className="space-y-2 text-sm">
              <li className="hover:text-primary-600 transition duration-300 cursor-pointer">
                Privacy Policy
              </li>

              <li className="hover:text-primary-600 transition duration-300 cursor-pointer">
                Terms & Conditions
              </li>

              <li className="hover:text-primary-600 transition duration-300 cursor-pointer">
                Support
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4">
              Contact
            </h3>

            <ul className="space-y-2 text-sm leading-6">
              <li>+91 74181 69679 | +91 95001 73908</li>
              <li>info@santechnovation.com</li>
              <li>9:30 AM – 6:30 PM (Mon – Sat)</li>
              <li>
                2nd Floor, VSM Complex, Near Anna Statue,
                Kanjikovil Road, Perundurai,
                Erode – 638052
              </li>
            </ul>
          </div>

        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-300 mt-12 pt-6 text-sm text-gray-600 text-center">
          © {new Date().getFullYear()} SAN Technovation Pvt Ltd. All rights reserved.
        </div>

      </div>
    </footer>
  );
};